import React, { useRef, useState } from 'react';
import SalesforceFieldError from './SalesforceFieldError';
const { exchangePlaceLabel } = require('../shared/exchangeEnglish');
const { buildQuestionLookup, isQuestionVisible } = require("../shared/progress");

export default function QuestionSearchC({ questionInfo, sousCritereIndex, questionIndex, updateQuestionSearchCode, getNumberFiliereActif, getNumberCritereActif, data }) {



    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */ 



    const inputLycee = useRef(null);
    const autocompleteResults = useRef(null);
    const suggestions_list = useRef(null);
    const searchInput = useRef(null);

    const isExchange = data?.configuration === 'Echange';
    const placeLabel = value => isExchange ? exchangePlaceLabel(value) : value;

    const [inputCode, setinputCode] = useState(questionInfo.code_postal);
    const [value, setValue] = useState(questionInfo.value);
    const [valueName, setValueName] = useState(placeLabel(questionInfo.valueName));

    const [villes, setVilles] = useState([]);

    const currentPeriod = data?.data?.[getNumberFiliereActif];
    const questionLookup = buildQuestionLookup(currentPeriod);
    const visible = isQuestionVisible(questionInfo, {
        dataFiltres: currentPeriod?.filtres,
        questionLookup
    });



    /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */ 


    /* --- RÉCUPÈRE TOUTES LES QUESTIONS ET EN RESSORT LES DÉPENDANCES AVEC LA QUESTION --- */


    /* --- MISE À JOUR DE LA VALEUR DU CHAMPS --- */
    function handleChange (newValue , newCode , newValueName) {
            setValue(newValue);
            setinputCode(newCode);
            setValueName(placeLabel(newValueName));
            updateQuestionSearchCode(sousCritereIndex, questionIndex, newValue , newCode , newValueName);
    };

    
    /* --- RÉCUPÈRE LES VALEURS DE VILLES DANS SERVER ET LES RETRANSCRIT DANS UNE LISTE --- */
    async function updateSuggestions() {
        // Partie asynchrone exécutée en premier
        (async () => {
            try {
                let response
                if (questionInfo.type_of_search === "lycee"){
                    response = await fetch('/backend/api/lycees');
                } else {
                    response = await fetch('/backend/api/villes');
                }
                const data = await response.json();
                setVilles(data);
            } catch (error) {
                console.error('Error fetching villes:', error);
            }
        })();
    
        // Le reste du code s'exécute immédiatement après, de manière synchrone
        setValueName(searchInput.current.value);
    
        const inputValue = removeAccents(searchInput.current.value.toLowerCase().replace(/-/g, ' ').replace(/\bsur\b/g, '/').replace(/\bst\b/g, 'saint').replace(/\bnd\b/g, 'notre dame'));
        //console.log(inputValue);
        const inputWords = inputValue.split(' ');
    
        var filteredLycees;

        filteredLycees = villes.filter(ville => {
            const lyceeName = removeAccents(placeLabel(ville[3]).toLowerCase().replace(/-/g, ' ').replace(/\bsur\b/g, '/').replace(/\bst\b/g, 'saint').replace(/\bnd\b/g, 'notre dame'));
            // Vérifier que tous les mots de la recherche sont inclus dans le nom
            return inputWords.every(word => lyceeName.includes(word));
        }).slice(0, 10);
        
    
        suggestions_list.current.innerHTML = "";
    
        filteredLycees.forEach(lycee => {
            const li = document.createElement("li");
            li.textContent = placeLabel(lycee[3]);
            li.setAttribute("data-codeUAI", lycee[1]);
            li.setAttribute("data-codePostal", lycee[0]);
            li.addEventListener("click", () => {
                inputLycee.current.value = li.getAttribute("data-codeUAI");
                if (questionInfo.type_of_search === "lycee"){
                    console.log(lycee)
                    handleChange(lycee[1],lycee[1],lycee[0]);                
                } else if (questionInfo.type_of_search === "ville"){
                    handleChange(lycee[1],lycee[2],lycee[0]);
                }
                autocompleteResults.current.style.display = "none";
            });
            suggestions_list.current.appendChild(li);
        });
    
        autocompleteResults.current.style.display = searchInput.current.value === "" ? "none" : "block";
    
        if (searchInput.current.value === "") {
            handleChange("", "", "");
        }
    }
    
    
    function removeAccents(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */ 

    if (!visible) return null;

        return (
            <div className="question" id={"id:"+questionInfo.id} style={{display:"block"}}>
    
                <div>
                    {/*Affiche un premier champs de recherche filtrant ex: département pour ville*/}
                    <label className="questionTitle">
                        {questionInfo.etiquette} :{questionInfo.required === "required" ? " *" : ""}
                    </label>
                    <div className="QuestionHelp" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />
    
                    <div className="ginput_container">
                        <label className="gfield_label searchHelpNote"></label>
                        {questionInfo.type_of_search === "ville" ? <p className="QuestionHelp">{isExchange ? "Enter the postal code, then select your city. For a city outside France, search for and select 'CITY OUTSIDE FRANCE'." : "⚠️Commencez par renseigner le code postal puis sélectionnez le choix correspondant. Si votre ville se situe à l'étranger, merci de renseigner 'VILLE À L'ÉTRANGER'"}</p> : ""}
                        {questionInfo.type_of_search === "lycee" ? <p className="QuestionHelp">{isExchange ? "Enter the postal code, then select your school. Choose 'Independent private school' where applicable, or 'School not listed' if you cannot find it." : "⚠️Commencez par renseigner le code postal puis sélectionnez le choix correspondant. Si votre établissement est un établissement hors contrat, sélectionnez 'Établissement hors contrat. Si vous ne trouvez pas votre établissement, sélectionner 'Établissement par défaut'"}</p> : ""}
                        <input id={questionInfo.name} aria-required="true" size="20" type="text" onChange={updateSuggestions} ref={searchInput} value={valueName} className="text">
                        </input>
                        <div ref={autocompleteResults} style={{ display: searchInput.value === "" ? 'block' : 'none' }}>
                            <ul ref={suggestions_list}></ul>
                        </div>
                    </div>
                    <div className="ginput_container" hidden>
                        <input id={questionInfo.idForm} name={questionInfo.idForm} value={value} ref={inputLycee} onChange={handleChange} aria-required="true" size="20" type="text"/>
                        <input id={questionInfo.idFormCode} name={questionInfo.idFormCode} value={inputCode} onChange={handleChange} aria-required="true" size="20" type="text"/>
                    </div>
                    {/* Refus du CRM : une question « recherche » alimente deux champs
                        (libellé et code postal), l'un ou l'autre peut être refusé. */}
                    <SalesforceFieldError error={questionInfo.salesforceError} />
                </div>
            </div>
        );
    
}
